var map = {
	"./demos/basic/index.ts": 28331,
	"./demos/border/index.ts": 69672,
	"./demos/closable/index.ts": 15492,
	"./demos/color/index.ts": 71126,
	"./demos/draggable/index.ts": 12691,
	"./demos/size/index.ts": 4250,
	"./demos/tags/index.ts": 35103
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96855;